import { createFileRoute } from '@tanstack/react-router';

// テストスイート詳細 > テスト対象機能タブ。
// 表示専用 (read-only) のため URL search のスキーマは持たない。
// コンポーネントは index.lazy.tsx 側で遅延ロードして bundle 分割する。
export const Route = createFileRoute(
  '/_stacktrace/test-suites/$id/_layout/target-functions/',
)({});
